import { ReactNode, useState } from 'react';

export default function Tooltip({
  content,
  children,
  position,
  className,
}: {
  content: ReactNode;
  children: ReactNode;
  position?: string;
  className?: string;
}) {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className="relative w-full">
      <div
        className="flex cursor-pointer items-center "
        onClick={() => setShowTooltip(!showTooltip)}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        {children}
      </div>
      {showTooltip && (
        <div
          className={`absolute w-max max-w-[200px] bottom-[-30px] ${className} ${
            position ? position : 'left-1/2'
          } bg-white  text-light-black border-light-black rounded-md py-1 px-2 pointer-events-none transition-all duration-300 z-[2000] border shadow-lg`}
        >
          {content}
        </div>
      )}
    </div>
  );
}
